module.exports = __webpack_public_path__ + "static/img/fayuan-icon1.efacc95d.png";